import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';
import { GAME_INFO_KEYS } from '../../core/constants/infoAndHashConstants';
import { applicationStore } from '../../store/applicationStore';
import { GameRulesKeno10, GameRulesKeno8 } from '../../core/constants/gameRules';
import { kenoBetStore } from '../../store/kenoBetStore';
import { userInfoStore } from '../../store/userInfoStore';
import { DEMO_GAME_CURRENCY } from '../../core/constants/gameConstants';

const Help = observer(() => {
  const { isKeno8, isDemo } = applicationStore;
  const { maxWinAmount } = kenoBetStore;
  const { currencyCode } = userInfoStore;

  const t = useTranslation();

  const drawTableValue = useCallback(
    (i, j, el) => {
      if (!i && !j) {
        return null;
      }
      if (!i || !j) {
        return el;
      }
      const text = t(`GAME_RULES_${i}_${j}`);
      return text === `GAME_RULES_${i}_${j}` ? null : text;
    },
    [t]
  );

  return (
    <div className='game-rules'>
      {GAME_INFO_KEYS.map((number) => {
        return (
          <p className='game-rules-txt' key={number}>
            {t(
              applicationStore.isKeno8
                ? TranslationKeys.GameRules8P + number
                : TranslationKeys.GameRules10P + number
            )}
          </p>
        );
      })}
      <div className='game-rules-table-block'>
        <div className='game-rules-table'>
          {(isKeno8 ? GameRulesKeno8 : GameRulesKeno10).map((el, i) => {
            return (
              <div className='game-rules-table-row'>
                {el.map((item, j) => {
                  return (
                    <div className='game-rules-table-item'>
                      <span className='game-rules-table-item-txt'>
                        {drawTableValue(i, j, item)}
                      </span>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
      <br />
      <p className='game-rules-txt'>
        {t(
          applicationStore.isKeno8 ? TranslationKeys.GameRules8P26 : TranslationKeys.GameRules10P26,
          { value: maxWinAmount }
        )}{' '}
        {isDemo ? DEMO_GAME_CURRENCY : currencyCode}
      </p>
    </div>
  );
});

export default Help;
